import platform from "platform";

export default () => {
  const isCompatible = platform.os.family == "Android" &&
    platform.name.startsWith("Chrome") &&
    platform.version.split(".")[0] >= 89 &&
    "NDEFReader" in window;
  return isCompatible;
}